const PLATES = [
  {
    delay: "[animation-delay:0s]",
    rest: "motion-reduce:[transform:translateZ(0)]",
    top: "tw-bg-[#2E2A78]",
    front: "tw-bg-[#232059]",
    back: "tw-bg-[#1A1845]",
    right: "tw-bg-[#26235F]",
    left: "tw-bg-[#1D1A4C]",
  },
  {
    delay: "[animation-delay:-1.1s]",
    rest: "motion-reduce:[transform:translateZ(10px)]",
    top: "tw-bg-[#5B4BF5]",
    front: "tw-bg-[#4437C4]",
    back: "tw-bg-[#372CA3]",
    right: "tw-bg-[#4A3CD6]",
    left: "tw-bg-[#3B2FAD]",
  },
  {
    delay: "[animation-delay:-2.2s]",
    rest: "motion-reduce:[transform:translateZ(20px)]",
    top: "tw-bg-[#A3E635]",
    front: "tw-bg-[#85BA20]",
    back: "tw-bg-[#6E9C18]",
    right: "tw-bg-[#93CC26]",
    left: "tw-bg-[#79A81C]",
  },
] as const;

const NexaLoader = ({ label = "Nexa is working" }: { label?: string }) => (
  <div role="status" aria-label={label} className="tw-relative tw-h-[58px] tw-w-12 tw-shrink-0 [perspective:420px]">
    <div
      className="tw-absolute tw-left-1/2 tw-top-[78%] tw--ml-[26px] tw--mt-[26px] tw-h-[52px] tw-w-[52px] tw-rounded-full tw-bg-[radial-gradient(circle,rgba(79,70,229,0.5)_0%,rgba(79,70,229,0)_70%)] tw-animate-nx-glow motion-reduce:tw-animate-none"
      aria-hidden="true"
    />

    <div className="tw-absolute tw-left-1/2 tw-top-[54%] tw-h-0 tw-w-0 [transform-style:preserve-3d] [transform:rotateX(58deg)_rotateZ(45deg)]" aria-hidden="true">
      {PLATES.map((plate) => (
        <div
          key={plate.top}
          className={`tw-absolute tw--ml-3 tw--mt-3 tw-h-6 tw-w-6 [transform-style:preserve-3d] tw-animate-nx-plate motion-reduce:tw-animate-none ${plate.delay} ${plate.rest}`}
        >
          <i className={`tw-absolute tw-inset-0 tw-block [transform:translateZ(3.5px)] ${plate.top}`} />
          <i className={`tw-absolute tw-left-0 tw-top-[8.5px] tw-block tw-h-[7px] tw-w-6 [transform:rotateX(90deg)_translateZ(12px)] ${plate.front}`} />
          <i className={`tw-absolute tw-left-0 tw-top-[8.5px] tw-block tw-h-[7px] tw-w-6 [transform:rotateX(-90deg)_translateZ(12px)] ${plate.back}`} />
          <i className={`tw-absolute tw-left-[8.5px] tw-top-0 tw-block tw-h-6 tw-w-[7px] [transform:rotateY(90deg)_translateZ(12px)] ${plate.right}`} />
          <i className={`tw-absolute tw-left-[8.5px] tw-top-0 tw-block tw-h-6 tw-w-[7px] [transform:rotateY(-90deg)_translateZ(12px)] ${plate.left}`} />
        </div>
      ))}
    </div>
  </div>
);

export default NexaLoader;
